import React from 'react';

const Eks = ({className, style, iconStyles}) => (
  <div className={className} style={{...style}}>
    <svg version="1.1" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="60px" height="60px" viewBox="0 0 60 60" style={{...iconStyles, enableBackground: 'new 0 0 60 60'}} xmlSpace="preserve"><path d="M40.7 42.1c-.3 0-.7-.1-1-.4L18.3 20.2c-.5-.5-.5-1.4 0-1.9s1.4-.5 1.9 0l21.5 21.5c.5.5.5 1.4 0 1.9-.3.2-.6.4-1 .4z" /><path d="M19.3 42.1c-.3 0-.7-.1-1-.4-.5-.5-.5-1.4 0-1.9l21.5-21.5c.5-.5 1.4-.5 1.9 0s.5 1.4 0 1.9L20.2 41.7c-.2.2-.6.4-.9.4z" /></svg>
  </div>
);

Eks.defaultProps = {
  style: {
    position:"absolute",
    zIndex:"0",
    bottom:0,
    right:1,
  },
  iconStyles: {
    width:"60px",
    height:"60px",
  }
};

export default Eks;
